export default __webpack_public_path__ + "static/media/guide_to_app.79a39f8c.jpg";